const randomInRange = (from, to) => Math.floor(Math.random() * (to - from + 1)) - to

export default randomInRange